module.exports = __webpack_public_path__ + "static/media/rosemont-pharmaceuticals.442c568e.jpg";